import React, {useState, useContext} from "react";
import {data} from './data';

const ContextApp = React.createContext();

const getLocalStorage = ()=>{
    let searchMovie = localStorage.getItem('searchMovie')
    if(searchMovie){
        return JSON.parse(localStorage.getItem('searchMovie'))
    }else{
        return []
    }
}

const getLocalStorage2 = ()=>{
    let tvResult = localStorage.getItem('tvResult')
    if(tvResult){
        return JSON.parse(localStorage.getItem('tvResult'))
    }else{
        return []
    }
}


export const AppProvider = ({children}) => {
    const [movieData, setMovieData] = useState([])
    const [movies, setMovies] = useState([])
    const [searchMovie, setSearchMovie] = useState(getLocalStorage())
    const [searchBar, setSerchBar] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isTrailerOpen, setIsTrailerOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [tvResult, setTvResult] = useState(getLocalStorage2())
 
    React.useEffect(()=>{
        localStorage.setItem('searchMovie', JSON.stringify(searchMovie))
    }, [searchMovie])

    React.useEffect(()=>{
        localStorage.setItem('tvResult', JSON.stringify(tvResult))
    }, [tvResult])

    const searchBarIcon = () => {
        return setSerchBar(!searchBar)
    }

    const openSidebar = () => {
        setIsSidebarOpen(true)
    }

    const closeSidebar = () => {
        setIsSidebarOpen(false)
    }

    const openTrailer = () =>{
        setIsTrailerOpen(true)
    }
    
    return(
        <ContextApp.Provider value={{movieData, setMovieData, searchMovie, setSearchMovie, searchBar, setSerchBar,searchBarIcon, movies, setMovies, openSidebar, closeSidebar, isSidebarOpen, setIsSidebarOpen, isTrailerOpen, setIsTrailerOpen, openTrailer, isLoading, setIsLoading, tvResult, setTvResult}}>
            {children}
        </ContextApp.Provider>
    )
} 

export const useGlobalContext = () => {
    return useContext(ContextApp)
}